// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer__6Qi6j"};